<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Reports" title="Work Report" />
 
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">
		
							<div class="col-md-12 project-list filter-sort">
								<div class="row">

									<div class="col-md-2">
										<label class="control-label">From Date:<span class="text-danger">*</span></label>
										<input class="form-control" type="date" v-model="start_date" :min="min" :max="max" value-as-string @change="fetchWorkReport()">
									</div>
									<div class="col-md-2">
										<label class="control-label">To Date:<span class="text-danger">*</span></label>
										<input class="form-control" type="date" v-model="end_date" :min="min" :max="max" value-as-string @change="fetchWorkReport()">
									</div>
									
									<div class="col-md-2">
										<label class="control-label">Product</label>
										<select class="form-select" v-model="product_id" @change="fetchWorkReport()">
											<option value="">All Products</option>
											<option v-for="product in products" :value="product.id">{{ product.product_name }}</option>
										</select>
									</div>

									<div class="col-md-2">
										<label class="control-label">Technician</label>
										<select class="form-select" v-model="technician_id" @change="fetchWorkReport()">
											<option value="">All Technicians</option>
											<option v-for="technician in technicians" :value="technician.id">{{ technician.name }}</option>
										</select>
									</div>

									<div class="col-md-2">
										<label class="control-label">Type</label>
										<select class="form-select" v-model="type" @change="fetchWorkReport()">
											<option value="">All Types</option>
											<option value="1">New</option>
											<option value="2">Repair</option>
											<option value="2">Replacement</option>
										</select>
									</div>
									
									<div class="col-md-2" style="margin-top: 33px; position: relative;">
										<div class="btn-group">
											<button type="button" class="btn btn-info dropdown-toggle" @click="toggleDropdown()">Download</button>
											<div class="dropdown-menu"  v-if="showDownloadOptions" style="display: block;">
												<a class="dropdown-item text-white bg-info" href="#" @click.prevent="generatePDF">Download PDF</a>
												<a class="dropdown-item text-white bg-info" href="#" @click.prevent="generateExcel">Download Excel</a>
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-2 d-flex mt-4">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchWorkReport()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="card">
						<div class="card-body">

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
											<th>Customer</th>
											<th>Location</th>
											<th>Product & Work Type</th>
											<th>Technician</th>
											<th>Date</th>
											<th>Total Amount</th> 
                                        </tr>
									</thead>
									<tbody v-if="Boolean(work_reports.length)">
                                        <tr align="center" v-for="(report, index) in work_reports">
                                            <td>{{ (from - 1) + index + 1 }}</td>
											<td>
												{{ report.customer_name }}<br>
												+91 {{ report.mobile }}
											</td>
											<td>{{ report.location }}</td>
											<td>
												{{ report.product_name }} 
												<br> 
												<span v-if="report.service_type == 1">New</span>
												<span v-else-if="report.service_type == 2">Repair</span>
												<span v-else>Replacement</span>
											</td>
											<td>{{ report.technician_name }}</td>
											<td>{{ report.date }}</td>
											<td>Rs.{{ report.total_amount }}</td>
                                        </tr>
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="7" class="text-center">No work reports found</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!--- pagination starts --->
							<div class="row mt-2">
								<div class="col-md-6">
									<p class="text-muted mb-0">
										Showing {{ from || 0 }} to {{ to || 0 }} of {{ total || 0 }} entries
									</p>
								</div>
								<div class="col-md-6">
									<nav aria-label="Page navigation">
										<ul class="pagination justify-content-end">
											<li class="page-item" v-for="(page, index) in pagination" :key="index" :class="[{ disabled: !page.url }, { active: page.active }]">
												<a class="page-link" href="#" @click.prevent="fetchWorkReport(page.url)" tabindex="-1">
													<span v-if="index === 0">Prev</span>
													<span v-else-if="index === pagination.length - 1">Next</span>
													<span v-else v-html="page.label"></span>
												</a>
											</li>
										</ul>
									</nav>
								</div>
							</div>
							<!--- pagination ends --->
		
						</div>
					</div>
				</div>
			</div>
		</div>

   	</div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import Swal from '@/utils/swal';
import { get, getFile } from '@/utils/api';
import { routes } from '@/constants/routes';

const router = useRouter();

// Set today's date
const now = new Date();
const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
const today_str = new Date().toISOString().slice(0, 10); // Format: yyyy-mm-dd

// Refs for state
const work_reports = ref([]);
const technicians = ref([]);
const products = ref([]);
const pagination = ref({});
const start_date = ref('2021-01-01');
const end_date = ref(today_str);
const technician_id = ref("");
const product_id = ref("");
const type = ref("");
const token = ref('');
const i = ref(1);
const from = ref(null);
const to = ref(null);
const total = ref(null);
const listing_length = ref(10);
const current_page = ref(1);

const min = start_date.value;
const max = today_str;

const showDownloadOptions = ref(false);

const toggleDropdown = () => {
	showDownloadOptions.value = !showDownloadOptions.value;
}

const closeDropdown = () => {
  showDownloadOptions.value = false;
};

const fetchTechnicians = () => {

	get(routes.AllTechnicians, {}, false)
		.then((response) => {
			if (response.status === 200) {
				console.log(response.data.data);
                technicians.value = response.data.data;
            } else {
                Swal.fire('', response.data.message || 'Error fetching data', 'error');
            }
		})
		.catch((error) => {
			if (error.response?.status === 422) {
                Swal.fire('', 'Validation error', 'error');
            } else if (error.response?.status === 500) {
                Swal.fire('', error.response.statusText || 'Server error', 'error');
            } else if (error.response?.status === 401) {
                Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
                router.push({ name: 'login' });
            } else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});
};

const fetchProducts = () => {

	get(routes.AllProducts, {}, false)
		.then((response) => {
			if (response.status === 200) {
				console.log(response.data.data);
                products.value = response.data.data;
            } else {
                Swal.fire('', response.data.message || 'Error fetching data', 'error');
            }
		})
		.catch((error) => {
			if (error.response?.status === 422) {
                Swal.fire('', 'Validation error', 'error');
            } else if (error.response?.status === 500) {
                Swal.fire('', error.response.statusText || 'Server error', 'error');
            } else if (error.response?.status === 401) {
                Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
                router.push({ name: 'login' });
            } else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});
};

const fetchWorkReport = (url = null) => {

	closeDropdown();

	if (url) {
		const urlObj = new URL(url);
		current_page.value = urlObj.searchParams.get('page') || 1;
	} else {
		current_page.value = 1;
	}

	const params = {
		limit: listing_length.value,
		from_date: start_date.value,
		to_date: end_date.value,
		technician_id: technician_id.value,
		product_id: product_id.value,
		type: type.value,
		page: current_page.value
	}

	const requestUrl = url ?? routes.WorkReport;

	get(requestUrl, { params }, false)
		.then((response) => {
			if (response.status === 200) {
				console.log(response.data.data);
                work_reports.value = response.data.data.data;
				pagination.value = response.data.data.links;
				from.value = response.data.data.from;
				to.value = response.data.data.to;
				total.value = response.data.data.total;
            } else {
                Swal.fire('', response.data.message || 'Error fetching data', 'error');
            }
		})
		.catch((error) => {
			if (error.response?.status === 422) {
                Swal.fire('', error.response.data.message.limit?.[0] || error.response.data.message.from_date?.[0] || error.response.data.message.to_date?.[0] || error.response.data.message.product_id?.[0] || error.response.data.message.technician_id?.[0] || error.response.data.message.type?.[0] || 'Validation error', 'error');
            } else if (error.response?.status === 500) {
                Swal.fire('', error.response.statusText || 'Server error', 'error');
            } else if (error.response?.status === 401) {
                Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
                router.push({ name: 'login' });
            } else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});
};

const generatePDF = () => {

	closeDropdown();

	const params = {
		limit: listing_length.value,
		from_date: start_date.value,
		to_date: end_date.value,
		technician_id: technician_id.value,
		product_id: product_id.value,
		type: type.value,
		page: current_page.value
	}

	getFile(routes.WorkReportPdf, params, false)
		.then((response) => {
			const fileURL = window.URL.createObjectURL(new Blob([response.data]));
			const fileLink = document.createElement('a');
			fileLink.href = fileURL;
			fileLink.setAttribute('download', 'WorkReport_' + start_date.value + '_' + end_date.value + '.pdf');
			document.body.appendChild(fileLink);
			fileLink.click();
			document.body.removeChild(fileLink);
			window.URL.revokeObjectURL(fileURL);
		})
		.catch((error) => {
			if (error.response?.status === 422) {
				const parseErrorBlob = async () => {
					try {
						let json = {};

						if (error.response.data instanceof Blob) {
							const text = await error.response.data.text();
							json = JSON.parse(text);
						} else {
							json = error.response.data;
						}

						const message = json.message || {};
						const firstError =
							message.limit?.[0] ||
							message.from_date?.[0] ||
							message.to_date?.[0] ||
							message.technician_id?.[0] ||
							'Validation error';

						Swal.fire('', firstError, 'error');
					} catch (e) {
						console.error('Failed to parse error blob:', e);
						Swal.fire('', 'Validation error', 'error');
					}
				};

				parseErrorBlob();            
			} else if (error.response?.status === 500) {
                Swal.fire('', error.response.statusText || 'Server error', 'error');
            } else if (error.response?.status === 401) {
                Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
                router.push({ name: 'login' });
            } else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});
};

const generateExcel = () => {

	closeDropdown();

	const params = {
		limit: listing_length.value,
		from_date: start_date.value,
		to_date: end_date.value,
		technician_id: technician_id.value,
		product_id: product_id.value,
		type: type.value,
		page: current_page.value
	}

	getFile(routes.WorkReportExcel	, params, false)
		.then((response) => {
			let fileName = 'WorkReport_' + start_date.value + '_' + end_date.value + '.xlsx';
			const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			const fileURL = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = fileURL;
			link.setAttribute('download', fileName);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			window.URL.revokeObjectURL(fileURL);
		})
		.catch((error) => {
			if (error.response?.status === 422) {
				const parseErrorBlob = async () => {
					try {
						let json = {};

						if (error.response.data instanceof Blob) {
							const text = await error.response.data.text();
							json = JSON.parse(text);
						} else {
							json = error.response.data;
						}

						const message = json.message || {};
						const firstError =
							message.limit?.[0] ||
							message.from_date?.[0] ||
							message.to_date?.[0] ||
							message.technician_id?.[0] ||
							'Validation error';

						Swal.fire('', firstError, 'error');
					} catch (e) {
						console.error('Failed to parse error blob:', e);
						Swal.fire('', 'Validation error', 'error');
					}
				};

				parseErrorBlob();            
			} else if (error.response?.status === 500) {
                Swal.fire('', error.response.statusText || 'Server error', 'error');
            } else if (error.response?.status === 401) {
                Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
                router.push({ name: 'login' });
            } else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});
};

onMounted(() => {
	fetchProducts();
	fetchTechnicians();
	fetchWorkReport();
});
</script>
